<template>
  <BaseOverlay>
    <!-- <h1>hello from create new payout</h1>
    <h1
    v-if="selectedDriver"
    >{{selectedDriver.id}}</h1> -->
    <!-- <h1
    v-if="driverWallet"
    >{{driverWallet}}</h1> -->
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="1"
      opacity="1"
      rounded="sm"
      :show="loadingDriverWallet"
    >
      <b-row
        v-if="driverWallet"
        class="bg-white"
      >
        <b-col md="12">
          <template>
            <div>
              <b-card
                v-if="selectedDriver"
                class="px-0 py-0 mt-1"
              >
                <b-row>
                  <b-col
                    md="4"
                    class="d-flex align-items-center"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="UserIcon"
                        class="mr-75"
                      />
                      <span class="font-weight-bold mr-1">Name:</span>
                      {{ selectedDriver.fullName }}
                    </div>
                  </b-col>
                  <b-col
                    md="4"
                    class="d-flex align-items-center"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="KeyIcon"
                        class="mr-1"
                      />
                      <span class="font-weight-bold mr-1">ID:</span>
                      {{ selectedDriver.driverId }}
                    </div>
                  </b-col>
                  <b-col
                    md="4"
                    class="d-flex align-items-center"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="PhoneIcon"
                        class="mr-1"
                      />
                      <span class="font-weight-bold mr-1">Phone Number:</span>
                      {{ selectedDriver.phoneNumber }}
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </template>
        </b-col>
        <b-col
          v-if="$can('read', 'driver-wallet-transactions')"
          md="6"
        >
          <driver-balance-statistics
            v-if="driverWallet"
            :balance-statistics="driverWallet.statistics.balance"
          />
        </b-col>
        <b-col
          v-if="$can('read', 'driver-wallet-transactions')"
          md="6"
        >
          <driver-pending-balance-statistics
            v-if="driverWallet"
            :pending-balance-statistics="driverWallet.statistics.pendingBalance"
          />
        </b-col>
        <b-col md="12">
          <template>
            <div>
              <b-card
                v-if="driverWallet"
                no-body
                class="px-1 py-1 driver-view__sticky-info"
              >
                <b-card-title :class="`mb-1 font-weight-bold ${hasEWallet ? 'text-success' : 'text-danger'}`">
                  E-Wallet
                </b-card-title>
                <b-row
                  v-for="Wallet in driverWallet.eWallet"
                  :key="Wallet.id"
                >
                  <b-col
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="CreditCardIcon"
                        class="mr-75"
                      />
                      <span class="font-weight-bold mr-1">Type:</span>
                      {{ Wallet.vendor }}
                    </div>
                  </b-col>
                  <b-col
                    md="2"
                    class="d-flex align-items-center"
                  >
                    <div
                      v-for="(value, name) in Wallet.meta"
                      :id="value"
                      :key="value"
                      class="d-flex align-items-center"
                    >
                      <feather-icon
                        icon="KeyIcon"
                        class="mr-75"
                      />
                      <span class="font-weight-bold mr-1">{{ name }}</span>
                      {{ value }}
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- alert with no E-Wallet for this Driver  -->
                  <b-col
                    v-if="!hasEWallet"
                    md="12"
                    class="d-flex align-items-center"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="AlertTriangleIcon"
                        class="mr-75 text-danger"
                      />
                      <span class="font-weight-bold mr-1">No E-Wallet added for selected driver, please let the Driver add E-Wallet to enable create payout request</span>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </template>
        </b-col>
        <b-col
          v-if="$can('read', 'driver-wallet-transactions') "
          md="12"
        >
          <b-overlay
            variant="white"
            spinner-variant="primary"
            blur="1"
            opacity="1"
            rounded="sm"
            :show="loadingUpdateDriverMinAmountOfPayout"
          >
            <!-- add field it show the minAmountOfPayout and make it updatable with -->
            <b-card
              v-if="driverWallet"
              no-body
              class="px-1 py-1 driver-view__sticky-info"
            >
              <b-card-title class="mb-1 font-weight-bold d-flex align-items-center justify-content-between">
                <div>
                  <feather-icon
                    icon="CreditCardIcon"
                    class="mr-75"
                  />
                  Minimum Amount of Payout
                </div>
                <feather-icon
                  :icon="`${showUpdateDriverMinAmountOfPayout ? 'XIcon' : 'EditIcon'}`"
                  :class="`cursor-pointer mx-1 edit-icon ${showUpdateDriverMinAmountOfPayout ? 'text-danger' : 'text-primary'}`"
                  @click="showUpdateDriverMinAmountOfPayout = !showUpdateDriverMinAmountOfPayout"
                />
              </b-card-title>
              <b-row>
                <b-col
                  md="12"
                  class="d-flex align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <div v-if="!showUpdateDriverMinAmountOfPayout">

                      <span class="font-weight-bold mr-1">Min Amount:</span>
                      {{ driverWallet.minAmountOfPayout || minAmountOfPayout }}
                    </div>
                    <div
                      v-if="!showUpdateDriverMinAmountOfPayout"
                      class="ml-3"
                    >

                      <span class="font-weight-bold mr-1">Amount can be paid:</span>
                      {{ maxAmountOfPayout || 0 }}
                    </div>
                    <b-form
                      v-if="showUpdateDriverMinAmountOfPayout"
                      class="d-flex justify-content-around"
                      @submit.prevent="UpdateDriverPayout"
                    >
                      <b-form-input
                        v-model="minAmountOfPayout"
                        type="number"
                        placeholder="Enter Min Amount"
                      />
                      <b-button
                        type="submit"
                        variant="primary"
                        class="ml-2"
                      >
                        Update
                      </b-button>
                    </b-form>
                  </div>
                  <!-- create new element with icon edit if the showUpdateDriverMinAmountOfPayout is false or will be an x icon and when user click on it will toggle the value -->
                </b-col>
              </b-row>
            </b-card>
          </b-overlay>
        </b-col>
      </b-row>
    </b-overlay>
    <div class="mt-2">
      <DriversSearch
        :auto-reset="false"
        :clearable="false"
        :filterable="false"
        @drivers-selection="onDriverSelection"
      />
      <!-- <small
        v-if="showErrorMessage2"
        class="text-danger"
        >
        Please select a {{ userType }}
      </small> -->
      <b-form
        v-if="selectedDriver && hasEWallet"
        class="pt-3"
      >
        <b-form-group>
          <b-form-input
            id="amount"
            v-model="amount"
            type="number"
            name="title"
            required
            placeholder="Enter Payout Amount"
          />
        </b-form-group>
        <small
          v-if="amount && amount < 5"
          class="text-danger"
        >
          Amount must be greater than 5
        </small>
        <b-button
          :disabled="!amount || amount < 5 || !hasEWallet"
          variant="primary"
          class="mt-2"
          block
          @click="submitPayoutRequest"
        >
          Submit
        </b-button>
      </b-form>
    </div>
  </BaseOverlay>
</template>

<script>
import {
  BCard, BRow, BCol, BOverlay, BForm, BFormInput, BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'

import store from '@/store'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import DriverBalanceStatistics from '@/views/driver/drivers-view/tabs/driver-wallet/DriverBalanceStatistics.vue'
import DriverPendingBalanceStatistics from '@/views/driver/drivers-view/tabs/driver-wallet/DriverPendingBalanceStatistics.vue'
import DriversSearch from '@/views/driver/components/DriversSearch.vue'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import driverViewStoreModule from '@/views/driver/drivers-view/driverViewStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BOverlay,
    BForm,
    BFormInput,
    BButton,
    BaseOverlay,
    DriversSearch,
    DriverBalanceStatistics,
    DriverPendingBalanceStatistics,
  },
  props: {
  },
  setup(props, ctx) {
    console.log(props)
    console.log(ctx)
    useRegisterStoreModule('driverView', driverViewStoreModule)
    const createPayoutRef = ref(null)
    const showEditSection = ref(false)

    const loadingDriverWallet = ref(false)
    const loadingUpdateDriverMinAmountOfPayout = ref(false)
    const driverWallet = ref(null)
    const selectedDriver = ref(null)
    const minAmountOfPayout = ref(5)
    const needUpdateDriverMinAmountOfPayout = ref(true)
    const showUpdateDriverMinAmountOfPayout = ref(false)
    const maxAmountOfPayout = ref(0)
    const amount = ref(null)

    const hasEWallet = ref(false)

    const toggleUpdateDriverMinAmountOfPayout = () => {
      showUpdateDriverMinAmountOfPayout.value = !showUpdateDriverMinAmountOfPayout.value
    }

    //   fetchDriverWallet
    const fetchDriverWallet = async id => {
      driverWallet.value = null
      hasEWallet.value = false
      loadingDriverWallet.value = true
      const driverWalletInfo = await store.dispatch('driverView/fetchDriverWallet', { id })
      driverWallet.value = driverWalletInfo
      loadingDriverWallet.value = false
      hasEWallet.value = driverWalletInfo.eWallet.length > 0
    }

    const UpdateDriverPayout = async () => {
      loadingUpdateDriverMinAmountOfPayout.value = true
      await axiosIns.patch(`/drivers/${selectedDriver.value.id}`, { minimumAmountOfPayout: minAmountOfPayout.value })
      needUpdateDriverMinAmountOfPayout.value = false
      // fetchDriverWallet(selectedDriver.value.id)
      showUpdateDriverMinAmountOfPayout.value = false
      if (hasEWallet.value) {
        maxAmountOfPayout.value = Math.floor(driverWallet?.value?.balance - minAmountOfPayout.value)
      }
      loadingUpdateDriverMinAmountOfPayout.value = false
    }

    const onDriverSelection = async Driver => {
      selectedDriver.value = await Driver
      await fetchDriverWallet(Driver.id)
      if (Driver.minimumAmountOfPayout) {
        minAmountOfPayout.value = Driver.minimumAmountOfPayout || 5
        if (hasEWallet.value) {
          maxAmountOfPayout.value = Math.floor(driverWallet?.value?.balance - minAmountOfPayout.value)
        }
        needUpdateDriverMinAmountOfPayout.value = false
      } else {
        needUpdateDriverMinAmountOfPayout.value = true
      }
    }

    const submitPayoutRequest = async () => {
      try {
        await axiosIns.post('/payouts', {
          driverId: selectedDriver.value.id,
          amount: amount.value,
        })
        successNotification('Payout Request Created Successfully')
        amount.value = null
        selectedDriver.value = null
      } catch (error) {
        const message = error?.response?.data?.error?.detail || 'Something went wrong'
        errorNotification(message)
      }
    }

    const submitDisabled = () => {
      if (amount?.value && !hasEWallet.value) {
        return true
      }
      if (amount?.value < 5) {
        return true
      }
      return false
    }

    return {
      onDriverSelection,
      selectedDriver,
      showEditSection,
      loadingDriverWallet,
      loadingUpdateDriverMinAmountOfPayout,
      driverWallet,
      minAmountOfPayout,
      hasEWallet,
      needUpdateDriverMinAmountOfPayout,
      UpdateDriverPayout,
      showUpdateDriverMinAmountOfPayout,
      toggleUpdateDriverMinAmountOfPayout,
      maxAmountOfPayout,
      amount,
      createPayoutRef,
      submitPayoutRequest,
      submitDisabled,
    }
  },
}

</script>

<style scoped>

</style>
